import React, {Component} from 'react';
import decorImg1 from './../../img/general/hero-decor.svg';
import decorImg2 from './../../img/general/how-we-work-1-decor.svg';
import decorImg3 from './../../img/general/how-we-work-2-decor.svg';
import decorImg4 from './../../img/general/how-we-work-4-decor.svg';
import decorImg5 from './../../img/general/how-we-work-3-decor.svg';
import decorImg6 from './../../img/general/how-we-work-3-decor-2.svg';
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {showContactPopup} from "../../actionCreators";

class LandingMain extends Component {

  handleShowContactPopup = (e) => {
    e.preventDefault();
    const {showContactPopup} = this.props;
    showContactPopup();
  };

  handleGoShop = () => {
    const {shops, history} = this.props;
    if(shops && shops.length !== 0) {
      let firstShop = shops[0].url_hash;
      history.push(`/shop/${firstShop}`);
    } else {
      history.push(`/shop/`);
    }
  };

  render() {
    const {handleShowContactPopup} = this;
    return (
      <main>
        <section className="hero">
          <div className="container">
            <div className="hero__inner">
              <div className="hero__left">
                <div className="hero__logo">
                  <h1>möbelpost.de</h1>
                </div>
                {/*<div className="hero__desc">*/}
                {/*  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>*/}
                {/*</div>*/}
                <div className="hero__links">
                  <a onClick={this.handleGoShop} className="hero__link hero__link--delivery">Lieferung vereinbaren</a>
                  <span>oder</span>
                  <a onClick={handleShowContactPopup} className="hero__link hero__link--contact hero__link--contact-js" href="#">Kontaktiere uns</a>
                </div>
              </div>
              <div className="hero__right">
                <img src={decorImg1} alt="" />
              </div>
            </div>
          </div>
        </section>
        <section className="how-we-work">
          <div className="container">
            <h2>Wie wir arbeiten?</h2>
            <div className="how-we-work__inner">
              <div className="how-we-work__row how-we-work__one">
                <div className="how-we-work__img">
                  <img src={decorImg2} alt="" />
                </div>
                <div className="how-we-work__desc">
                  <p>Preis für Ihre Sofortlieferung jetzt ausrechnen</p>
                </div>
              </div>
              <div className="how-we-work__row how-we-work__two">
                <div className="how-we-work__desc">
                  <p>Nach einer Auftragserteilung geht Ihre Bestellung an den nächsten verfügbaren Möbelspediteur in Ihrer Nähe. Dadurch werden die Anfahrtszeiten erheblich gekürzt und der beste Lieferpreis ermöglicht.</p>
                </div>
                <div className="how-we-work__img">
                  <img src={decorImg3} alt="" />
                </div>
              </div>
              <div className="how-we-work__row how-we-work__three">
                <div className="how-we-work__img">
                  <img className="how-we-work__three--desktop" src={decorImg5} alt="" />
                  <img className="how-we-work__three--mobile" src={decorImg6} alt=""/>
                </div>
                <div className="how-we-work__desc">
                  <p>Wählen Sie ein Zeitfenster für Ihre Lieferung aus</p>
                </div>
              </div>
              <div className="how-we-work__row how-we-work__four">
                <div className="how-we-work__desc">
                  <p>WIr lieferen Ihre Ware direkt zu Ihnen nach Hause</p>
                </div>
                <div className="how-we-work__img">
                  <img src={decorImg4} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="about-us">
          <div className="container">
            <h2>Über uns</h2>
            <div className="about-us__inner">
              <p>Möbelpost ist ein erfolgreiches Startup Unternehmen, das aus einem umfangreichen Netz geprüfter Spediteure besteht. Um eine schnellstmögliche und günstige Lieferung zu gewährleisten, wird direkt nach Ihrer Bestellung ein Möbelspediteur mit kürzester Anfahrtszeit kontaktiert. Unser Algorythmus rechnet dabei genau die Volumen Ihrer Lieferung aus und sucht für Sie ein passendes Lieferfahrzeug.
                <Link to="/shop/" className="hero__link hero__link--delivery" href="#">Lieferung vereinbaren</Link>
              </p>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    shops: state.shops.shopList
  }
}, {showContactPopup})(LandingMain));


// WEBPACK FOOTER //
// ./src/components/Landing/LandingMain.js